import { useFormPrimitiveStyles } from "../formPrimitives";
import { SearchableSelect } from "./SearchableSelect";
import { AMTSGERICHT_OPTIONS } from "../../../data/amtsgerichte";
import { SperrWert } from "../SperrWert";

/**
 * Handelsregister-Erfassung: volle Handelsregisternummer inkl. Registerart in
 * EINEM Feld ("HRB 12345") + zuständiges Amtsgericht (Registergericht) als
 * SUCHBARE Combobox (tippen filtert die ~117 Gerichte, Bundesland als Hinweis).
 * Angezeigt wird später „Amtsgericht <Stadt> HRB 12345". 2-Spalten-Layout wie
 * die übrigen Widgets.
 *
 * Reihenfolge: erst die Nummer, das Amtsgericht am Ende — so steht es auch in
 * Registerauszug und Impressum, und so wird es abgetippt.
 */
export function HandelsregisterInput({
  amtsgerichtLabel = "Zuständiges Amtsgericht",
  numberLabel = "Handelsregisternummer",
  numberPlaceholder = "z. B. HRB 12345",
  amtsgerichtValue,
  numberValue,
  onAmtsgerichtChange,
  onNumberChange,
}: {
  amtsgerichtLabel?: string;
  numberLabel?: string;
  /** Die Registerart gehört mit in die Nummer — beim Verein „VR 1234". */
  numberPlaceholder?: string;
  amtsgerichtValue: string;
  numberValue: string;
  onAmtsgerichtChange: (v: string) => void;
  onNumberChange: (v: string) => void;
}) {
  const s = useFormPrimitiveStyles();

  return (
    <div className={s.row}>
      <div className={s.field}>
        <label className={s.label} htmlFor="handelsregisterNummer">{numberLabel}</label>
        <div className={s.inputWrap}>
          <input
            id="handelsregisterNummer"
            name="handelsregisterNummer"
            className={s.input}
            value={numberValue}
            placeholder={numberPlaceholder}
            onChange={(e) => onNumberChange(e.target.value)}
          />
          <SperrWert />
        </div>
      </div>
      {/* Suchbar: tippen filtert; nur gelistete Gerichte (kein Freitext). */}
      <SearchableSelect
        label={amtsgerichtLabel}
        name="registergericht"
        value={amtsgerichtValue}
        onChange={onAmtsgerichtChange}
        options={AMTSGERICHT_OPTIONS}
        allowFreeText={false}
        placeholder="Amtsgericht suchen …"
        emptyText="Kein Amtsgericht gefunden"
      />
    </div>
  );
}

export default HandelsregisterInput;
